import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  profiles: [],
  profile: null,
  sortAd: [],
  currentPage: null
}

const mutations = {  
  SET_PROFILES (state, payload) {
    state.profiles = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  SET_PROFILE (state, payload) {
    state.profile = payload
  },
  SET_SORT_AD (state, payload) {
    state.sortAd = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  profileList: (context, id) => {
    return Vue.http.get(`${env.API}/api/profile`)    
      .then((response) => {        
        context.commit('SET_PROFILES', response.body.message ? response.body.message : response.body)
        return response.body.message ? response.body.message : response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  paginatedList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/profile/paginated-list`, data)    
      .then((response) => {        
        context.commit('SET_PROFILES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  },
  deleteProfile: (context, data) => {
    return Vue.http.delete(`${env.API}/api/profile/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  getProfileById: (context, id) => {
    return Vue.http.get(`${env.API}/api/profile/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_PROFILE', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateProfile: (context, data) => {
    return Vue.http.put(`${env.API}/api/profile/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createProfile: (context, data) => {
    return Vue.http.post(`${env.API}/api/profile`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  }
}

const getters = {
  getProfiles: (state) => state.profiles,
  getProfile: (state) => state.profile,
  getSortAd: (state) => state.sortAd,
  getCurrentPage: (state) => state.currentPage
}

export const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js